import React from "react";
import { ModalHeaderStyled } from "./ModalHeaderStyled";
import { ModalHeaderProps } from "../../../entities/Modal";
import CloseIcon from "../../../UI/Icons/CloseIcon";
import Typography from "../../../UI/Typography";
import { TYPOGRAPHY_TYPE } from "../../../entities/Typography";
import { useAppDispatch } from "../../../store/store";
import { onCloseModal } from "../slice/ModalSlice";

const ModalHeader: React.FC<ModalHeaderProps> = ({
  title,
  style,
}: ModalHeaderProps) => {
  const dispatch = useAppDispatch();
  return (
    <ModalHeaderStyled style={style}>
      <div className="modal-header__title">
        <Typography type={TYPOGRAPHY_TYPE.TITLE_FOUR}>{title}</Typography>
      </div>
      <div
        className="modal-header__close"
        onClick={() => dispatch(onCloseModal())}
      >
        <CloseIcon />
      </div>
    </ModalHeaderStyled>
  );
};

export default ModalHeader;
